///
/// Called to verify the password entry form. The "password" and "verify" strings are what the user
/// entered in each of the fields. If the password is good, we return true, otherwise we return a
/// string with the error message.
///
export const verifyPasswordEntryForm = (password?: string, verify?: String): string | true => {
  if (password !== verify) {
    return 'The passwords typed do not match.'
  }

  // They match, now just make sure the rules are good.
  return verifyPassword(password)
}

///
/// Verify that the provided password matches the given rules. Note that if the rules change, then
/// visit passwordRulesString to change what is returned.
///
const verifyPassword = (password?: string): string | true => {
  if (!password || password.length < 8) {
    return 'The password is not long enough, it must be at least 8 characters.'
  }

  return true
}

///
/// Returns a string which displays the rules for the type of passwords we accept.
///
export const passwordRulesString = (): string => {
  return 'Passwords must be at least 8 characters long.'
}
